import React, { useState, useEffect } from "react";
// import "bootstrap/dist/css/bootstrap.min.css"; // Импорт Bootstrap
import Header from "./containers/Header/Header";
import Bitrix from "./containers/Bitrix/Bitrix";
import Information from "./containers/Information/Information";
import Dimensions from "./containers/Dimensions/Dimensions";
import Offer from "./containers/Offer/Offer";

function App() {
  const [dealId, setDealId] = useState(null);
  const [selfPickUp, setSelfPickUp] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("cash");
  const [distanceFromFactory, setDistanceFromFactory] = useState(null);
  const [region, setRegion] = useState("СПБ")
  const [typeRoof, setTypeRoof] = useState("single-slope");
  const [sum, setSum] = useState(0)
  const [typeOptions, setTypeOptions] = useState([
    {
      value: "single-slope",
      label: "Односкатная",
      image: "/images_small/roof-type-1.png",
      imageBig: "/images_big/roof_1.png",
      parameters: [
        { name: "Ширина ската по карнизу (W), м:", value: "" },
        { name: "Длина ската по торцу (Н), м:", value: "" },
        { name: "Максимальная длина листа, м:", value: 3.6 },
      ],
    },
    {
      value: "gable",
      label: "Двускатная",
      image: "/images_small/roof-type-2.png",
      imageBig: "/images_big/roof_2.png",
      parameters: [
        { name: "Длина конька/Ширина ската по карнизу (W), м:", value: "" },
        { name: "Длина ската 1 (H1), м:", value: "" },
        { name: "Длина ската 2 (H2), м:", value: "" },
        { name: "Максимальная длина листа, м:", value: 3.6 },
      ],
    },

    {
      value: "hip",
      label: "Вальмовая",
      image: "/images_small/roof-type-3.png",
      imageBig: "/images_big/roof_3.png",
      parameters: [
        { name: "Ширина ската 1 (W1), м:", value: "" },
        { name: "Ширина ската 2 (W2), м:", value: "" },
        { name: "Ширина конька (W3), м:", value: "" },
        { name: "Длина ската 1 (H1), м:", value: "" },
        { name: "Длина ската 2 (H2), м:", value: "" },
        { name: "Максимальная длина листа, м:", value: 3.6 },
      ],
    },

    {
      value: "tent",
      label: "Шатровая",
      image: "/images_small/roof-type-4.png",
      imageBig: "/images_big/roof_4.png",
      parameters: [
        { name: "Ширина ската 1 (W1), м:", value: "" },
        { name: "Ширина ската 2 (W2), м:", value: "" },
        { name: "Длина ската 1 (H1), м:", value: "" },
        { name: "Длина ската 2 (H2), м:", value: "" },
        { name: "Максимальная длина листа, м:", value: 3.6 },
      ],
    },

    {
      value: "attic",
      label: "Мансардная",
      image: "/images_small/roof-type-5.png",
      imageBig: "/images_big/roof_5.png",
      parameters: [
        { name: "Длина конька/Ширина ската по карнизу (W), м:", value: "" },
        { name: "Длина ската 1 (H1), м:", value: "" },
        { name: "Длина ската 2 (H2), м:", value: "" },
        { name: "Максимальная длина листа, м:", value: 3.6 },
      ],
    },
  ]);

  const [locationFromDeal, setLocationFromDeal] = useState({
    address: "Мурино, Всеволожский район, Ленинградская область", // Начальный адрес
    coordinates: {
      latitude: 60.051284, // Начальная широта
      longitude: 30.438578, // Начальная долгота
    },
  });

  const [addressAndCoordinates, setAddressAndCoordinates] = useState({
    address: "Владивосток",
    coordinates: {
      latitude: 43.115542, //широта
      longitude: 131.885494, //долгота
    },
  });

  useEffect(() => {
    console.log(sum)
  }, [sum, typeOptions])

  

  const [selectedNomenclature, setSelectedNomenclature] = useState(null);


  // Функция для обновления `value` в `parameters`
  const handleParameterChange = (roofValue, paramIndex, newValue) => {
    setTypeOptions((prevOptions) =>
      prevOptions.map((roof) =>
        roof.value === roofValue
          ? {
              ...roof,
              parameters: roof.parameters.map((param, index) =>
                index === paramIndex ? { ...param, value: newValue } : param
              ),
            }
          : roof
      )
    );
  };

  return (
    <div className="bg-light" style={{ minHeight: "100vh", paddingBottom: "200px" }}>
      <Bitrix setDealId={setDealId} />
      <Header />
      <Information
        selfPickUp={selfPickUp}
        setSelfPickUp={setSelfPickUp}
        paymentMethod={paymentMethod}
        setPaymentMethod={setPaymentMethod}
        addressAndCoordinates={addressAndCoordinates}
        setAddressAndCoordinates={setAddressAndCoordinates}
        dealId={dealId}
        typeOptions={typeOptions}
        typeRoof={typeRoof}
        setTypeRoof={setTypeRoof}
        selectedNomenclature={selectedNomenclature}
        setSelectedNomenclature={setSelectedNomenclature}
        setDistanceFromFactory={setDistanceFromFactory}
        distanceFromFactory={distanceFromFactory}
        region={region}
        setRegion={setRegion}
      />
      <Dimensions
        typeRoof={typeRoof}
        typeOptions={typeOptions}
        onParameterChange={handleParameterChange} // Передаем функцию для изменения значений
        selectedNomenclature={selectedNomenclature}
        setSum={setSum}
        sum={sum}
      />
      <Offer
        typeRoof={typeRoof}
        typeOptions={typeOptions}
        selectedNomenclature={selectedNomenclature}
        dealId={dealId}
        distanceFromFactory={distanceFromFactory}
        region={region}
        sum={sum}
      />
    </div>
  );
}
export default App;
